var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountInfoSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 4.66667H13.3332H5.33317ZM13.3332 4.66667L10.6665 2L13.3332 4.66667ZM13.3332 4.66667L10.6665 7.33333L13.3332 4.66667ZM10.6665 11.3333H2.6665H10.6665ZM2.6665 11.3333L5.33317 14L2.6665 11.3333ZM2.6665 11.3333L5.33317 8.66667L2.6665 11.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 11.3333L5.33317 8.66667M5.33317 4.66667H13.3332H5.33317ZM13.3332 4.66667L10.6665 2L13.3332 4.66667ZM13.3332 4.66667L10.6665 7.33333L13.3332 4.66667ZM10.6665 11.3333H2.6665H10.6665ZM2.6665 11.3333L5.33317 14L2.6665 11.3333Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountInfoSave);
export default __webpack_public_path__ + "static/media/account-info-save.4de6099c2836f1d17235eb247f9b8096.svg";
export { ForwardRef as ReactComponent };